import { apiObject } from './apiobject'

const excerpttypes = {
    ...apiObject,
    url: '/excerpttypes/',
}

export default {
    excerpttypes
}
